import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../../api";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import { Loader } from "../loader";
import { useAlert } from "react-alert";

export function AddSummary({ setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();
  const [value, setValue] = useState("");
  const [title, setTitle] = useState("");
  const [loader, setLoader] = useState(false);

  const [inputData, setInputData] = useState({
    summary: "",
  });

  const handleSubmit = async () => {
    try {
      if (inputData.summary) {
        setLoader(true);
        let payload = {
          _id: adminStore.admin.admin._id,
          summary: inputData.summary,
        };
        // console.log(payload);
        const signalResponse = await api.summaryCreate(payload);
        if (signalResponse?.success) {
          alert.show("Summary created successfully");
          setInputData({
            summary: "",
          });
          setLoader(false);

          setShow(false);
          // sendNotification()
        } else {
          setLoader(false);
          alert.show("Something went wrong");
        }
      } else {
        setLoader(false);
        alert.show("Please insert summary");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.show("Something went wrong");
    }
  };

  var Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const handleChange = (e) => {
    // console.log(e);
    setInputData({ ...inputData, summary: e });
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Add Trade Summary
                </h4>
              </div>
            </div>
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                {/* <div className="form-group mb-3">
                                <input type="text" className='form-control' onChange={(e)=>setTitle(e.target.value)} placeholder='Title...' />
                              </div> */}
                <div className="descMainPost">
                  <ReactQuill
                    placeholder="Enter summary"
                    modules={Editor}
                    theme="snow"
                    value={inputData.summary}
                    onChange={handleChange}
                  />
                </div>

                <div className="sendMailBtn mt-3">
                  <button onClick={handleSubmit} className="btn-dark">
                    Submit
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
